import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListReferralCommission from "../Components/Referral Commission/listReferralCommission";
import ViewReferralCommission from "../Components/Referral Commission/viewReferralCommission";
import AddReferralCommission from "../Components/Referral Commission/addReferralCommission";
import EditReferralCommission from "../Components/Referral Commission/editReferralCommission";

const ReferralsRoutes = () => {
    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
  
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    // const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');
  return (
    <Routes>
      <Route
        path="/referral_commission"
        element={<ListReferralCommission></ListReferralCommission>}
      ></Route>
      <Route
        path="/referral_commission/view/:id"
        element={<ViewReferralCommission></ViewReferralCommission>}
      ></Route>
      <Route
        path="/referral_commission/add"
        element={canAdd ? <AddReferralCommission></AddReferralCommission> : <Navigate to="/referral_commission" replace />}
      ></Route>
      <Route
        path="/referral_commission/edit/:id"
        element={<EditReferralCommission></EditReferralCommission>}
      ></Route>
    </Routes>
  );
};

export default ReferralsRoutes;
